import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import Swal from "sweetalert2";

class GuestReviews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comments: [],
      loading: false,
      submitLoading: false,
      formData: {
        comment_details: "",
        comment_star: 5,
      },
    };
  }

  componentDidMount() {
    this.fetchComments();
  }

  fetchComments = async () => {
    try {
      this.setState({ loading: true });
      const response = await axios.get(`/comments/${this.props.postId}`);
      this.setState({
        comments: response.data.data || [],
        loading: false,
      });
    } catch (error) {
      console.error(error);
      this.setState({
        loading: false,
      });
    }
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      formData: {
        ...this.state.formData,
        [name]: value,
      },
    });
  };

  submitComment = async (e) => {
    e.preventDefault();
    const customer_id = localStorage.getItem("web_user_id");

    // Check login
    if (!customer_id) {
      Swal.fire({
        icon: "warning",
        title: "Login Required",
        text: "Please login first to submit review",
      });
      return;
    }

    // Validation
    if (
      !this.state.formData.comment_details ||
      this.state.formData.comment_details.trim() === ""
    ) {
      Swal.fire({
        icon: "warning",
        title: "Empty Comment",
        text: "Please write your comment",
      });
      return;
    }

    try {
      this.setState({ submitLoading: true });
      const payload = {
        post_id: this.props.post_id,
        customer_id: customer_id,
        comment_details: this.state.formData.comment_details,
        comment_star: this.state.formData.comment_star,
      };

      const response = await axios.post("/comments/create", payload);

      if (response.data.status === "success") {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data.message,
          timer: 1500,
          showConfirmButton: false,
        });

        // reset form immediately
        this.setState({
          formData: {
            comment_details: "",
            comment_star: 5,
          },
        });

        // 🔥 live refresh
        await this.fetchComments();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.message,
        });
      }
      this.setState({ submitLoading: false });
    } catch (error) {
      console.error(error);
      this.setState({ submitLoading: false });
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "Something went wrong",
      });
    }
  };

  returnAverageRating = () => {
    const { comments } = this.state;
    if (comments.length === 0) return 0;
    const total = comments.reduce(
      (sum, item) => sum + parseInt(item.comment_star || 0),
      0
    );
    return (total / comments.length).toFixed(1);
  };

  calculateStarPercentage = (starNum) => {
    const { comments } = this.state;
    if (comments.length === 0) return "0%";
    const count = comments.filter(
      (c) => parseInt(c.comment_star || 0) === starNum
    ).length;
    return `${Math.round((count / comments.length) * 100)}%`;
  };

  renderFAStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (rating >= i) {
        stars.push(<i key={i} className="fas fa-star"></i>);
      } else if (rating >= i - 0.5) {
        stars.push(<i key={i} className="fas fa-star-half-alt"></i>);
      } else {
        stars.push(<i key={i} className="far fa-star text-secondary"></i>);
      }
    }
    return stars;
  };

  render() {
    const { comments, formData, loading, submitLoading } = this.state;
    const customer_id = localStorage.getItem("web_user_id");
    const avgRating = this.returnAverageRating();

    return (
      <section className="mb-5 pb-4 border-bottom">
        <h3 className="fw-bold mb-4 section-heading">Guest Reviews</h3>

        {/* Rating Summary (New UI) */}
        <div className="d-flex align-items-center gap-4 mb-4 p-4 bg-light rounded-4 border">
          <div className="text-center">
            <h1 className="display-4 fw-bold text-dark mb-0">{avgRating}</h1>
            <div className="text-warning fs-5">
              {this.renderFAStars(parseFloat(avgRating))}
            </div>
            <span className="text-secondary small">
              Based on {comments.length} reviews
            </span>
          </div>
          <div className="flex-grow-1 border-start ps-4 d-none d-sm-block">
            {[5, 4, 3, 2, 1].map((num) => (
              <div key={num} className="d-flex align-items-center gap-2 mb-1">
                <span className="small text-secondary" style={{ width: "35px" }}>
                  {num} <i className="fas fa-star text-warning small"></i>
                </span>
                <div className="progress flex-grow-1" style={{ height: "6px" }}>
                  <div
                    className="progress-bar bg-success"
                    style={{ width: this.calculateStarPercentage(num) }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </div>

   

        {/* Comments List (New UI Cards) */}
        <div className="review-cards d-flex flex-column gap-3 mb-5">
          {loading ? (
            <div className="text-center py-4 text-secondary">
              <div className="spinner-border spinner-border-sm me-2" role="status"></div>
              Loading reviews...
            </div>
          ) : comments.length === 0 ? (
            <div className="text-center py-4 text-secondary">
              No reviews available yet.
            </div>
          ) : (
            comments.map((item, index) => (
              <div
                key={index}
                className="review-card p-4 rounded-4 border bg-white shadow-sm"
              >
                <div className="d-flex justify-content-between mb-3">
                  <div className="d-flex align-items-center gap-3">
                    <div
                      className="rounded-circle bg-dark text-white d-flex justify-content-center align-items-center"
                      style={{ width: "45px", height: "45px", fontSize: "1.2rem" }}
                    >
                      {item.full_name ? item.full_name.charAt(0).toUpperCase() : "U"}
                    </div>
                    <div>
                      <h6 className="fw-bold mb-0">
                        {item.full_name || "Anonymous User"}
                      </h6>
                      <span className="text-secondary small">
                        {item.created_at
                          ? new Date(item.created_at).toLocaleDateString()
                          : "Recently"}
                      </span>
                    </div>
                  </div>
                  <div className="text-warning">
                    <i className="fas fa-star"></i> {Number(item.comment_star).toFixed(1)}
                  </div>
                </div>
                <p className="text-secondary mb-0">{item.comment_details}</p>
              </div>
            ))
          )}
        </div>
      </section>
    );
  }
}

export default GuestReviews;
